import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GlobalHotKeys } from "react-hotkeys";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
const keyMap = {
  DeveloperDebug: {
    name: "Used for debugging",
    key: 3,
    sequence: "alt+1+2+3",
  },
  ShowQuickHelpSidebar: {
    name: "Show/Hide Quick Help Sidebar",
    key: 0,
    sequence: "ctrl+q",
  },
  ShowFirmTamerTimer: {
    name: "Show/Hide FirmTamer Timer",
    key: 1,
    sequence: "alt+q",
  },
  ShowShortcutsHelper: {
    name: "Show/Hide Shortcut List",
    key: 2,
    sequence: "alt+w",
  },
};
const handlers = {
  ShowQuickHelpSidebar: (event) => {
    window.$("#notepad-activator").click();
    window.$("#offCanvasNotepad").focus();
  },
  ShowFirmTamerTimer: (event) => {
    window.$("#timer-activator").click();
    window.$("#offCanvasNotepad").focus();
  },
  ShowShortcutsHelper: (event) => {
    window.$("#shortcuts-activator").click();
    window.$("#offCanvasNotepad").focus();
  },
  DeveloperDebug: () => {
    console.log("debugging!");
  },
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfigProvider
    componentSize="large"
    locale={"en_US"}
    theme={{ components: { Collapse: { contentPadding: 0 } }, token: { fontFamily: `"Hind Vadodara", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif` } }}
  >
    <BrowserRouter>
      <GlobalHotKeys keyMap={keyMap} handlers={handlers}>
        <App />
      </GlobalHotKeys>
    </BrowserRouter>
  </ConfigProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
